/**
 * ESTABLISHMENT CREATE METHOD MODAL
 * Choose how to add establishments.
 */
import CardButton from "@/components/card-button"
import Modal from "@/components/modal"
import Space from "@/components/space"
import Button from "@/components/button"
import { faPen, faSyncAlt, faTimes } from "@fortawesome/free-solid-svg-icons"
import { t } from "i18next"

interface Props {
  onManual: () => void
  onSync: () => void
  onClose: () => void
}

export default function EstablishmentCreateMethodModal({ onManual, onSync, onClose }: Props) {
  return (
    <Modal
      title="Ajouter un établissement"
      footer={
        <div className="flex w-full m-[-5px] mt-20">
          <Space />
          <Button onClick={onClose} className="med" icon={faTimes} isWithBorder>
            {t("utils_close")}
          </Button>
        </div>
      }>
      <div className="flex gap-4">
        <CardButton icon={faSyncAlt} title="Synchroniser" isCta onClick={onSync} />
        <CardButton icon={faPen} title="Ajouter manuellement" onClick={onManual} />
      </div>
    </Modal>
  )
}
